export const formatTramRoutes = (
  routes: string[] | null | undefined,
): string => (routes?.length ? routes.join(', ') : '[отсутствуют]');

export const formatTramRoutesWithLabel = (
  routes: string[] | null | undefined,
  routesReverse: string[] | null | undefined,
  routesLabel: string,
  routesReverseLabel: string,
): string => {
  const routesStraightString = routes
    ? `${routesLabel} ${formatTramRoutes(routes)}`
    : null;
  const routesReverseString = routesReverse
    ? `${routesReverseLabel} ${formatTramRoutes(routesReverse)}`
    : null;
  return routesStraightString && routesReverseString
    ? `${routesStraightString}, ${routesReverseString}`
    : routesStraightString && !routesReverseString
      ? routesStraightString
      : !routesStraightString && routesReverseString
        ? routesReverseString
        : null;
};
